import React, { useState, useEffect } from 'react'
import moment from 'moment'

import View from './View'
import { callAuthorizedGraphQLEndpoint } from './../../Module/graphQL'
import { urlGet } from './../../Utils/URL'

import { fetchAllClientsByChunks } from './gql'
import { authorization } from 'Module/Auth/Auth'

import {
  CAMPAIGN_ENUM_TYPES,
  STATUS_CAMPAIGN_ENUM_ACTIVE,
  STATUS_CAMPAIGN_ENUM_ARCHIVE,
  STATUS_CAMPAIGN_ENUM_COMPLETED,
  STATUS_CAMPAIGN_ENUM_DRAFT,
} from '../../shared/constants'

export default props => {
  const [filters, setFilters] = useState(null)
  const user = authorization.getUser()
  // Get all the filter options
  useEffect(() => {
    ;(async function() {
      const { clients, countries } = await fetchAllClientsByChunks({
        chunkSize: 100,
      })
      setFilters([
        {
          label: 'Status',
          options: [
            { label: 'Active', value: STATUS_CAMPAIGN_ENUM_ACTIVE },
            { label: 'Completed', value: STATUS_CAMPAIGN_ENUM_COMPLETED },
            { label: 'Draft', value: STATUS_CAMPAIGN_ENUM_DRAFT },
            { label: 'Archived', value: STATUS_CAMPAIGN_ENUM_ARCHIVE },
          ],
          selectedValue: urlGet('Status'),
        },
        {
          label: 'Country',
          options: countries.map(c => ({ label: c.name, value: c.id })),
          selectedValue: urlGet('Country') || user.countryName,
        },
        {
          label: 'Type',
          options: [
            { label: 'Hand to hand', value: CAMPAIGN_ENUM_TYPES.HANDTOHAND },
            { label: 'Letterbox', value: CAMPAIGN_ENUM_TYPES.LETTERBOX },
            { label: 'Direct Mail', value: CAMPAIGN_ENUM_TYPES.DIRECTMAIL },
          ],
          selectedValue: urlGet('Type'),
        },
        {
          label: 'Client',
          options: clients.map(c => ({ label: c.name, value: c.id })),
          selectedValue: urlGet('Client'),
        },
        {
          label: 'startDate',
          options: [],
          selectedValue: moment()
            .startOf('year')
            .format('YYYY-MM-DDTHH:mm:ssZ'),
        },
        {
          label: 'endDate',
          options: [],
          selectedValue: moment().format('YYYY-MM-DDTHH:mm:ssZ'),
        },
      ])
    })()
  }, [])

  const fetchData = async args => {
    const { first, skip } = args
    const shouldFetchActiveDates = [
      STATUS_CAMPAIGN_ENUM_ARCHIVE,
      STATUS_CAMPAIGN_ENUM_ACTIVE,
      STATUS_CAMPAIGN_ENUM_DRAFT,
      undefined,
    ].includes(args['Status'])

    const response = await callAuthorizedGraphQLEndpoint(
      `
        query (
          $clientIds: [ID!],
          $countryIds: [ID!],
          $types: [CampaignTypeEnum!],
          $statuses: [CampaignStatusEnum!],
          $startDate:String,
          $endDate:String,
          $first: Int,
          $skip: Int
        ) {
          campaigns(
            first: $first, 
            skip: $skip,
            clientIds:$clientIds, 
            countryIds:$countryIds, 
            types: $types,
            statuses: $statuses,
            startDate: $startDate,
            endDate: $endDate
          ){
            totalCount
            edges {
              node {
                id
                name
                type
                status
                country {
                  name
                }
                client {
                  name
                  logo
                }
                cityPlans {
                  totalCount
                }
                ${
                  shouldFetchActiveDates
                    ? `
                      activeDates{
                        start
                        end
                      }`
                    : ''
                }
              }
            }
          }
        }
      `,
      {
        first,
        skip,
        statuses: args['Status'] ? [args['Status']] : undefined,
        types: args['Type'] ? [args['Type']] : undefined,
        countryIds: args['Country'] ? [args['Country']] : undefined,
        clientIds: args['Client'] ? [args['Client']] : undefined,
        startDate: args['startDate'] ? args['startDate'] : undefined,
        endDate: args['endDate'] ? args['endDate'] : undefined,
      },
    )

    const result = await response.json()
    if (result['errors'] && result['errors'][0])
      throw new Error(result['errors'][0]['message'])

    const data = result['data']['campaigns']['edges'].map(edge => {
      let campaignTimeRange = null
      if (shouldFetchActiveDates) {
        const formatDate = date => new Date(date).toLocaleDateString()

        const startDate = edge.node.activeDates.start
        const endDate = edge.node.activeDates.end

        if (startDate && endDate) {
          const startDateFormatted = formatDate(startDate)
          const endDateFormatted = formatDate(endDate)
          campaignTimeRange = `${startDateFormatted} - ${endDateFormatted}`
        }
      }
      return {
        id: edge.node.id,
        name: edge.node.name,
        type: edge.node.type,
        country: edge.node.country.name,
        status: edge.node.status,
        client: edge.node.client.name,
        clientLogo: edge.node.client.logo,
        totalCities: edge.node.cityPlans.totalCount,
        campaignTimeRange,
        startDate: edge.node.activeDates.start,
      }
    })
    const sortedCampaignsByClient = data.reduce((acc, item) => {
      acc[item.client] = [...(acc[item.client] || []), item].sort(function(
        a,
        b,
      ) {
        if (a.startDate < b.startDate) return -1
        if (a.startDate > b.startDate) return 1
        return 0
      })
      return Object.values(acc).flat()
    }, [])
    return {
      data: sortedCampaignsByClient,
      totalCount: result['data']['campaigns']['totalCount'],
    }
  }

  if (!filters) return <div>Loading filters...</div>

  return <View {...props} filters={filters} fetchData={fetchData} />
}



// WEBPACK FOOTER //
// ./src/Containers/Campaigns/Container.js